import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";

import { PrimaryButton } from "../../Default/LekUI/Button";

interface ControllersProps {
	onChange: (index: number) => void;
	currentIndex: number;
	length: number;
}

function Controllers({ onChange, currentIndex, length }: ControllersProps) {
	const { t } = useTranslation();

	const onPrev = () => {
		if (currentIndex === 0) {
			return;
		}

		onChange(currentIndex - 1);
	};

	const onNext = () => {
		if (currentIndex + 1 === length) {
			return;
		}

		onChange(currentIndex + 1);
	};

	return (
		<div className="flex items-center justify-between">
			<PrimaryButton
				size="small"
				startIcon={<ArrowBackIcon />}
				onClick={onPrev}
			>
				{t("commands.prev")}
			</PrimaryButton>
			<span className="text-grey">
				{currentIndex + 1}/{length}
			</span>
			<PrimaryButton
				size="small"
				endIcon={<ArrowForwardIcon />}
				onClick={onNext}
			>
				{t("commands.next")}
			</PrimaryButton>
		</div>
	);
}

export default Controllers;
